import { call, put, select, takeLatest } from 'redux-saga/effects'
import { OptionsService } from '../services/options.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { getServiceIdSelector } from '../../user/selectors'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setCommonAddressesOptions as setCommonAddressesOptionsAction } from '../store/options.actions'

export function* setCommonAddressesOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getCommonAddressesOptions])
    const { entity } = response

    yield put(setCommonAddressesOptionsAction(entity))
  } catch (e) {
    yield put(throwPcrException(`setCommonAddressesOptions() error: ${e}`))
  }
}
export function* setCommonAddressesOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setCommonAddressesOptions)
}
